import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { MessageCircle, MessagesSquare, Phone, X } from "lucide-react";
import { SALES_PHONE_DISPLAY, SALES_PHONE_TEL, SALES_WHATSAPP_URL } from "../data/sitePages";

const ChannelChooser = ({ className = "zild-btn zild-btn-secondary", label = "Converse agora com nossa IA" }) => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (!open) return undefined;
        const close = (event) => event.key === "Escape" && setOpen(false);
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        window.addEventListener("keydown", close);
        return () => {
            document.body.style.overflow = previousOverflow;
            window.removeEventListener("keydown", close);
        };
    }, [open]);

    const openChat = () => {
        window.ZildChat_API?.show?.();
        window.ZildChat_API?.maximize?.();
        setOpen(false);
    };

    return (
        <>
            <button type="button" className={className} onClick={() => setOpen(true)} data-testid="ai-channel-chooser">
                {label}
            </button>
            {open && typeof document !== "undefined" ? createPortal((
                <div className="zild-channel-modal" role="presentation" onMouseDown={() => setOpen(false)}>
                    <section
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="zild-channel-title"
                        className="zild-channel-modal__panel"
                        onMouseDown={(event) => event.stopPropagation()}
                    >
                        <button type="button" className="zild-channel-modal__close" onClick={() => setOpen(false)} aria-label="Fechar">
                            <X size={18} />
                        </button>
                        <span>Teste a experiência</span>
                        <h2 id="zild-channel-title">Por onde você quer conversar com a nossa IA?</h2>
                        <p>Escolha o canal mais conveniente. A mesma IA SDR responde dúvidas e pode agendar uma conversa 24/7.</p>
                        <div className="zild-channel-modal__options">
                            <button type="button" onClick={openChat}>
                                <MessagesSquare size={21} />
                                <strong>Chat</strong>
                                <small>Converse aqui no site</small>
                            </button>
                            <a href={SALES_WHATSAPP_URL} target="_blank" rel="noreferrer">
                                <MessageCircle size={21} />
                                <strong>WhatsApp</strong>
                                <small>Continue pelo WhatsApp</small>
                            </a>
                            <a href={SALES_PHONE_TEL}>
                                <Phone size={21} />
                                <strong>Telefone</strong>
                                <small>{SALES_PHONE_DISPLAY}</small>
                            </a>
                        </div>
                    </section>
                    <style>{`
                        .zild-channel-modal { position: fixed; inset: 0; width: 100vw; min-height: 100vh; min-height: 100dvh; z-index: 2147482990; display: grid; place-items: center; padding: 20px; background: rgba(20, 13, 25, .78); backdrop-filter: blur(8px); }
                        .zild-channel-modal__panel { position: relative; width: min(680px, 100%); padding: 34px; border: 1px solid var(--zild-border); border-radius: var(--zild-radius-lg); background: var(--zild-warm-paper); box-shadow: var(--zild-shadow-panel-strong); }
                        .zild-channel-modal__panel > span { color: var(--zild-action); font-family: var(--zild-font-mono); font-size: 10px; letter-spacing: .09em; text-transform: uppercase; }
                        .zild-channel-modal__panel h2 { max-width: 560px; margin: 10px 0 0; color: var(--zild-aubergine-ink); font-size: clamp(1.65rem, 4vw, 2.25rem); line-height: 1.12; }
                        .zild-channel-modal__panel > p { max-width: 580px; margin: 14px 0 24px; color: var(--zild-text-muted); line-height: 1.6; }
                        .zild-channel-modal__close { position: absolute; top: 18px; right: 18px; width: 36px; height: 36px; display: grid; place-items: center; border: 1px solid var(--zild-border); border-radius: 999px; background: var(--zild-surface); color: var(--zild-text); cursor: pointer; }
                        .zild-channel-modal__options { display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px; }
                        .zild-channel-modal__options a, .zild-channel-modal__options button { min-width: 0; display: grid; gap: 7px; padding: 20px; text-align: left; border: 1px solid var(--zild-border); border-radius: var(--zild-radius-md); background: var(--zild-surface); color: var(--zild-aubergine-ink); cursor: pointer; font: inherit; }
                        .zild-channel-modal__options a:hover, .zild-channel-modal__options button:hover { border-color: var(--zild-action); transform: translateY(-2px); }
                        .zild-channel-modal__options svg { color: var(--zild-action); }
                        .zild-channel-modal__options strong { font-size: 15px; }
                        .zild-channel-modal__options small { color: var(--zild-text-muted); font-size: 12px; line-height: 1.4; }
                        @media (max-width: 620px) { .zild-channel-modal__panel { padding: 28px 20px 20px; } .zild-channel-modal__options { grid-template-columns: 1fr; } }
                    `}</style>
                </div>
            ), document.body) : null}
        </>
    );
};

export default ChannelChooser;
